"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFocusManager = void 0;
/**
 * A hook for managing focus of elements within a list.
 * @param props props for configuring the hook
 * @param props.itemElementRole the role of the item elements
 * @param props.orientation indicates whether the list is horizontally or vertically oriented
 * @returns properties to be applied to the list element
 */
const useFocusManager = ({ itemElementRole = 'tab', orientation = 'horizontal' }) => {
    const handleKeyDown = (event) => {
        var _a, _b, _c, _d, _e, _f;
        const { target } = event;
        const targetElement = target;
        const role = targetElement === null || targetElement === void 0 ? void 0 : targetElement.getAttribute('role');
        if (role !== itemElementRole) {
            return;
        }
        const previousKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        const nextKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        let newFocusTarget = null;
        switch (event.key) {
            case previousKey:
                newFocusTarget =
                    (_a = targetElement.previousElementSibling) !== null && _a !== void 0 ? _a : (_b = targetElement.parentElement) === null || _b === void 0 ? void 0 : _b.lastElementChild;
                break;
            case nextKey:
                newFocusTarget =
                    (_c = targetElement.nextElementSibling) !== null && _c !== void 0 ? _c : (_d = targetElement.parentElement) === null || _d === void 0 ? void 0 : _d.firstElementChild;
                break;
            case 'Home':
                newFocusTarget = (_e = targetElement.parentElement) === null || _e === void 0 ? void 0 : _e.firstElementChild;
                break;
            case 'End':
                newFocusTarget = (_f = targetElement.parentElement) === null || _f === void 0 ? void 0 : _f.lastElementChild;
                break;
            default:
                break;
        }
        if (newFocusTarget != null) {
            newFocusTarget === null || newFocusTarget === void 0 ? void 0 : newFocusTarget.focus();
            event.preventDefault();
        }
    };
    return {
        'aria-orientation': orientation,
        onKeyDown: handleKeyDown
    };
};
exports.useFocusManager = useFocusManager;
//# sourceMappingURL=useFocusManager.js.map